<app-lot-edit-menu [id]="id"></app-lot-edit-menu>
<router-outlet></router-outlet>
